module.exports = __webpack_public_path__ + "static/technology-9e21a27dbed5c4668bf2b65aab2529a7.png";